import React, { Fragment, useState } from 'react';
import { Button, Form, FloatingLabel, Row, Col, Container, Accordion } from 'react-bootstrap';
import LrfService from '../../../../services/lrf';
import { Link } from 'react-router-dom';
import Exportar from '../../../../components/shared/export'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDatabase } from '@fortawesome/free-solid-svg-icons';



const FormBusca = (props) => {
    const [ano, setAno] = useState("");
    const [bimestre, setBimestre] = useState("");
    const [pathName, setPathName] = useState(window.location.pathname)



    const busca = async (query) => {
        if (query == "") {
            props.setAindaTem(true)
            await props.fetchLrfIn()
            setAno("")
        } else {
            var response = await LrfService.buscar(query)
            if (response.data.length >= 1) {
                props.setLrfs(response.data)
                props.setAindaTem(false)
                props.setVazio(false)
                setAno("")

            } else {
                props.setVazio(true)
                setAno("")

            }
        }
    }

    const preparaQuery = async () => {
        let prepQuery = "";
        const tipo = await getTipo();
        if (bimestre !== "false" && bimestre !== "") prepQuery = prepQuery + `bimestre=${bimestre}`;
        if (ano) prepQuery = prepQuery + `&ano=${ano}`;
        if (tipo) prepQuery += `&tipo=${tipo}`;
        return prepQuery;
    }

    const handleKeyDown = async (e) => {
        e.preventDefault();
        let finalQuery = await preparaQuery();
        await busca(finalQuery)
    }

    const getTipo = async () => {
        if (pathName === '/transparencia/lrf/rreo') return 'RREO';
        if (pathName === '/transparencia/lrf/rgf') return 'RGF';
        if (pathName === '/transparencia/lrf/dcrgf') return 'DCRGF';
        return '';
    };

    const renderOptions = () => {

        if (pathName === '/transparencia/lrf/rreo') {
            return (
                <>
                    <option>TODOS</option>
                    <option value="1bim">1º Bimestre</option>
                    <option value="2bim">2º Bimestre</option>
                    <option value="3bim">3º Bimestre</option>
                    <option value="4bim">4º Bimestre</option>
                    <option value="5bim">5º Bimestre</option>
                    <option value="6bim">6º Bimestre</option>
                </>
            );
        } else if (pathName === '/transparencia/lrf/rgf') {
            return (
                <>
                    <option>TODOS</option>
                    <option value="1sem">1º Semestre</option>
                    <option value="2sem">2º Semestre</option>
                    <option value="1qua">1º Quadrimestre</option>
                    <option value="2qua">2º Quadrimestre</option>
                    <option value="3qua">3º Quadrimestre</option>
                </>
            );
        } else if (pathName === '/transparencia/lrf/dcrgf') {
            return (
                <>
                    <option>TODOS</option>
                    <option value="ano">Anual</option>
                </>
            );
        } else {
            return <option>Selecione uma opção</option>;
        }
    };

    return (
        <Fragment>
            <Container>
                <div className="da-espaco">
                    <Row xs={1} lg={5}>
                        <Col xs={12} lg={5}>
                            <Form.Group className="mb-3" controlId="Ano">
                                <FloatingLabel
                                    label="Ano"
                                    className="mb-3"
                                >
                                    <Form.Control
                                        required
                                        type="number"
                                        name="ano"
                                        value={ano}
                                        onChange={e => setAno(e.target.value)} />
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col xs={12} lg={5}>
                            <Form.Group className="mb-3" controlId="Bimestre">
                                <FloatingLabel
                                    label="Bimestre"
                                    className="mb-3"
                                >
                                    <Form.Select
                                        required
                                        aria-label="Bimestre"
                                        name="bimestre"
                                        onChange={e => setBimestre(e.target.value)}
                                    >
                                        {renderOptions()}
                                    </Form.Select>
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col xs={12} lg={1}>
                            <Button onClick={async (e) => handleKeyDown(e)} type='button' variant='primary'>Buscar</Button>
                        </Col>
                        <Col xs={12} lg={1}>
                            <Link to='/lrf'>
                                <Button type='button' variant='danger'>Voltar</Button>
                            </Link>
                        </Col>
                    </Row>
                    <Accordion>
                        <Accordion.Item eventKey="0">
                            <Accordion.Header><strong>Dados Abertos <FontAwesomeIcon icon={faDatabase} /></strong></Accordion.Header>
                            <Accordion.Body>
                                <Row xs={1}>
                                    <Col xs={12}>
                                        <Exportar data={props.lrfs} nome={"LRFS"} />
                                    </Col>
                                </Row>
                                <br />
                                <Row xs={1}>
                                    <Col xs={12}>
                                        <a href="https://documenter.getpostman.com/view/19738229/2sA3BrWp4P#877ad7ec-b4a9-4d70-9e1e-e5eb2722fda9" target='_blank'>
                                            <Button>API e sua documentação</Button>
                                        </a>
                                    </Col>
                                </Row>
                            </Accordion.Body>
                        </Accordion.Item>
                    </Accordion>
                </div>
            </Container>
        </Fragment>
    )
}

export default FormBusca
